import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { Tooltip, TextField, MenuItem } from "@mui/material";
import { NumericFormat } from "react-number-format";
import { currentTenant, dataaccess, financialyearend, financialyearstart, thousandsdisplay, userid, currency } from "../../Common/Credentials.js";
import { spin } from "../../Common/NewLoader.jsx";
import Menu from "../../Component/Menu.js";
import Header from "../../Component/Header.js";
import Footer from "../../Component/Footer.js";
import SalesServices from "../SalesServices.js";
import { salesid } from "../../Common/Permissions.js";
import moment from 'moment';
import Swal from 'sweetalert2';

// Import CSS
import '../../NewUI/NewUI.css';

// Import icons
import ViewIcon from "../../images/Icons/preview.png";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";

class Creditnotes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initiated: [],
      compdata: [],
      nadata: [],
      loading: false,
      activeTab: 'pending',
      hovered: null,
      hoveredRow: null,
      isActionHovered: null,
      searchTerm: "",
      showSearch: false,
      isMobile: window.innerWidth <= 768,
      currentPage: 1,
      itemsPerPage: 20,
      sortConfig: { key: 'id', direction: 'asc' },
      filteredPendingData: [],
      filteredCompletedData: [],
      filteredNAData: [],
    };
    this.handleResize = this.handleResize.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.sortData = this.sortData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleItemsPerPageChange = this.handleItemsPerPageChange.bind(this);
    this.refreshItems = this.refreshItems.bind(this);
  }

  // Sort indicator component
  SortIndicator = ({ columnKey }) => {
    if (this.state.sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return this.state.sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  }

  // Sorting function
  sortData(key) {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, direction } });
  }

  getSortedData(data) {
    if (!this.state.sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (this.state.sortConfig.key) {
        case 'id':
          aValue = a.id || 0;
          bValue = b.id || 0;
          break;
        case 'customer':
          aValue = a.customer || '';
          bValue = b.customer || '';
          break;
        case 'invid':
          aValue = a.invid || 0;
          bValue = b.invid || 0;
          break;
        case 'itemname':
          aValue = a.itemname || '';
          bValue = b.itemname || '';
          break;
        case 'quantity':
          aValue = Number(a.quantity) || 0;
          bValue = Number(b.quantity) || 0;
          break;
        case 'price':
          aValue = Number(a.price) || 0;
          bValue = Number(b.price) || 0;
          break;
        case 'totalwtax':
          aValue = Number(a.totalwtax) || 0;
          bValue = Number(b.totalwtax) || 0;
          break;
        case 'createdAt':
          aValue = new Date(a.createdAt).getTime();
          bValue = new Date(b.createdAt).getTime();
          break;
        case 'refund':
          aValue = a.refund || '';
          bValue = b.refund || '';
          break;
        default:
          aValue = a[this.state.sortConfig.key] || '';
          bValue = b[this.state.sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return this.state.sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.state.sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlightSearchText(text, searchTerm) {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = this.escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'UI-search-highlight'
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  formatCurrency(value, searchTerm = null) {
    if (value === null || value === undefined) return '0';

    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    const prefix = currency === "INR" ? "₹ " : currency === "USD" ? "$ " : currency + " ";

    const formattedNumber = Number(numericValue).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const fullFormattedString = `${prefix}${formattedNumber}`;

    if (searchTerm) {
      return this.highlightSearchText(fullFormattedString, searchTerm);
    }

    return (
      <NumericFormat
        displayType="text"
        value={numericValue}
        decimalScale={2}
        fixedDecimalScale={true}
        thousandSeparator={true}
        thousandsGroupStyle={thousandsdisplay}
        prefix={prefix.trim()}
      />
    );
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
    if (!isMobile) {
      this.setState({ showSearch: false });
    }
  }

  refreshItems() {
    let datadao = {
      tenantid: currentTenant,
      startdate: financialyearstart,
      enddate: financialyearend,
      userid: userid,
      dataaccess: dataaccess,
    }

    SalesServices.getCreditNotes(datadao).then(res => {
      const pendingData = res.data.filter(e => e.refund !== "NotApplicable" && e.status === "Processing").sort((a, b) => a.createdAt < b.createdAt ? 1 : -1);
      const completedData = res.data.filter(e => e.refund !== "NotApplicable" && e.status === "Completed").sort((a, b) => a.createdAt < b.createdAt ? 1 : -1);
      const naData = res.data.filter(e => e.refund === "NotApplicable").sort((a, b) => a.createdAt < b.createdAt ? 1 : -1);

      this.setState({
        initiated: pendingData,
        compdata: completedData,
        nadata: naData,
        filteredPendingData: pendingData,
        filteredCompletedData: completedData,
        filteredNAData: naData,
        loading: false,
      });
    })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          Swal.fire({
            title: "Your Session is Lost",
            text: "Please login back to resume",
            icon: "error",
            confirmButtonText: "OK",
            confirmButtonColor: "#152f5f",
          }).then(() => this.props.navigate(`/`));
        }
      })
  }

  componentDidMount() {
    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume');
      this.props.navigate(`/`);
    }

    if (window.innerWidth <= 768) {
      this.setState({ showSearch: true });
    }
    window.addEventListener('resize', this.handleResize);

    this.setState({ loading: true });
    this.refreshItems();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleSearch(term) {
    this.setState({ searchTerm: term }, () => {
      this.updateFilteredData();
    });
  }

  updateFilteredData() {
    const { searchTerm, activeTab, initiated, compdata, nadata } = this.state;

    const filterData = (data) => {
      if (!searchTerm.trim()) return data;

      const cleanSearch = searchTerm.replace(/[^\w₹$€]/g, '').toLowerCase();

      return data.filter((item) => {
        const checkFields = [
          item.id?.toString(),
          item.customer,
          item.invid?.toString(),
          item.category,
          item.itemname,
          item.quantity?.toString(),
          item.price?.toString(),
          item.tax,
          item.taxamount?.toString(),
          item.totalwtax?.toString(),
          item.refund,
        ];

        return checkFields.some((field) => {
          if (field === undefined || field === null) return false;

          const raw = String(field);
          const cleanField = raw.replace(/[^\w₹$€]/g, '').toLowerCase();

          return (
            cleanField.includes(cleanSearch) ||
            raw.toLowerCase().includes(searchTerm.toLowerCase())
          );
        });
      });
    };

    this.setState({
      filteredPendingData: filterData(initiated),
      filteredCompletedData: filterData(compdata),
      filteredNAData: filterData(nadata),
      currentPage: 1,
    });
  }

  getCurrentData() {
    const { activeTab, filteredPendingData, filteredCompletedData, filteredNAData } = this.state;

    switch (activeTab) {
      case 'pending':
        return filteredPendingData;
      case 'completed':
        return filteredCompletedData;
      case 'na':
        return filteredNAData;
      default:
        return filteredPendingData;
    }
  }

  getCurrentPageData() {
    const currentData = this.getCurrentData();
    const { currentPage, itemsPerPage } = this.state;
    const sortedData = this.getSortedData(currentData);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return sortedData.slice(indexOfFirstItem, indexOfLastItem);
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage });
  }

  handleItemsPerPageChange(e) {
    this.setState({
      itemsPerPage: parseInt(e.target.value),
      currentPage: 1
    });
  }

  renderTabs() {
    const { activeTab, filteredPendingData, filteredCompletedData, filteredNAData } = this.state;

    const tabs = [
      { key: 'pending', label: 'Pending', count: filteredPendingData.length },
      { key: 'completed', label: 'Completed', count: filteredCompletedData.length },
      { key: 'na', label: 'Not Applicable', count: filteredNAData.length },
    ];

    return (
      <div className="UI-quotation-tabs-container">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`UI-quotation-tab ${activeTab === tab.key ? 'UI-quotation-active-tab' : ''
              } ${this.state.hovered === `${tab.key}-tab`
                ? 'UI-quotation-tab-hovered'
                : ''
              }`}
            onClick={() => this.setState({
              activeTab: tab.key,
              currentPage: 1,
              sortConfig: { key: 'id', direction: 'asc' }
            })}
            onMouseEnter={() => this.setState({ hovered: `${tab.key}-tab` })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {tab.label}
            {tab.count > 0 && (
              <span className="UI-match-count">{tab.count}</span>
            )}
          </div>
        ))}
      </div>
    );
  }

  renderPagination() {
    const { currentPage, itemsPerPage, isMobile } = this.state;
    const currentData = this.getCurrentData();

    if (currentData.length <= itemsPerPage) return null;

    const totalPages = Math.ceil(currentData.length / itemsPerPage);

    return (
      <div className={`UI-pagination-container ${isMobile ? 'UI-pagination-container-mobile' : ''}`}>
        <div className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, currentData.length)} of {currentData.length} credit notes
        </div>
        <div className={`UI-pagination-controls ${isMobile ? 'UI-pagination-controls-mobile' : ''}`}>
          <TextField
            select
            value={itemsPerPage}
            onChange={this.handleItemsPerPageChange}
            variant="outlined"
            size="small"
            className={`UI-page-size-select ${isMobile ? 'UI-page-size-select-mobile' : ''} ${this.state.hovered === 'pagesize' ? 'UI-page-size-select-hover' : ''}`}
            onMouseEnter={() => this.setState({ hovered: 'pagesize' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            <MenuItem value={5}>5 per page</MenuItem>
            <MenuItem value={10}>10 per page</MenuItem>
            <MenuItem value={20}>20 per page</MenuItem>
            <MenuItem value={50}>50 per page</MenuItem>
          </TextField>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'first' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'first' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'First' : 'First'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'prev' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'prev' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Prev' : 'Previous'}
          </button>

          <span className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'next' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'next' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Next' : 'Next'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'last' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'last' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Last' : 'Last'}
          </button>
        </div>
      </div>
    );
  }

  renderTable() {
    const isMobile = this.state.isMobile;
    const currentPageData = this.getCurrentPageData();
    const currentData = this.getCurrentData();

    if (currentData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {this.state.searchTerm ? 'No credit notes found matching your search' : 'No credit notes available'}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'id' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('id')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    ID
                    <this.SortIndicator columnKey="id" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customer' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('customer')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Customer
                    <this.SortIndicator columnKey="customer" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'invid' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('invid')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Tax Invoice
                    <this.SortIndicator columnKey="invid" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'itemname' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('itemname')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Item
                    <this.SortIndicator columnKey="itemname" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'quantity' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('quantity')}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                >
                  <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                    Quantity
                    <this.SortIndicator columnKey="quantity" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'price' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('price')}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                >
                  <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                    Unit Price
                    <this.SortIndicator columnKey="price" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'totalwtax' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('totalwtax')}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                >
                  <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                    Total
                    <this.SortIndicator columnKey="totalwtax" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('createdAt')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Date
                    <this.SortIndicator columnKey="createdAt" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'refund' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('refund')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Type
                    <this.SortIndicator columnKey="refund" />
                  </div>
                </th>
                {salesid === '2' || salesid === '3' ? (
                  <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`} style={{ textAlign: 'center' }}>
                    Actions
                  </th>
                ) : null}
              </tr>
            </thead>

            <tbody>
              {currentPageData.map((item) => (
                <tr
                  key={item.id}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === item.id ? 'UI-table-row-hovered' : ''}`}
                  onMouseEnter={() => this.setState({ hoveredRow: item.id })}
                  onMouseLeave={() => {
                    this.setState({ hoveredRow: null, isActionHovered: null });
                  }}
                >
                  {/* ID */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === item.id ? 'UI-item-name-hover' : ''}`}
                  >
                    {this.highlightSearchText(item.id, this.state.searchTerm)}
                  </td>

                  {/* CUSTOMER */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(item.customer, this.state.searchTerm)}
                  </td>

                  {/* TAX INVOICE */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    <Link
                      to={{ pathname: "/viewsalesinvoice" }}
                      state={{
                        id: item.invid,
                        pagename: "Tax Invoice Details",
                        type: "Tax Invoice",
                      }}
                      className="UI-link"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {this.highlightSearchText(item.invid, this.state.searchTerm)}
                    </Link>
                  </td>

                  {/* ITEM */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(item.itemname, this.state.searchTerm)}
                  </td>

                  {/* QUANTITY */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                    style={{ textAlign: 'right' }}
                  >
                    {this.highlightSearchText(item.quantity, this.state.searchTerm)}
                  </td>

                  {/* UNIT PRICE */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                    style={{ textAlign: 'right' }}
                  >
                    {this.formatCurrency(item.price, this.state.searchTerm)}
                  </td>

                  {/* TOTAL */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount ${this.state.hoveredRow === item.id ? 'UI-price-hover' : ''}`}
                    style={{ textAlign: "right" }}
                  >
                    {this.formatCurrency(item.totalwtax, this.state.searchTerm)}
                  </td>

                  {/* DATE */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {moment(item.createdAt).format("DD-MM-YYYY HH:mm:ss")}
                  </td>

                  {/* TYPE */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    <span className={`UI-status-badge ${item.refund === 'Completed' ? 'UI-status-completed' :
                      item.refund === 'Processing' ? 'UI-status-pending' :
                        'UI-status-na'}`}>
                      {this.highlightSearchText(item.refund, this.state.searchTerm)}
                    </span>
                  </td>

                  {/* ACTION BUTTONS */}
                  {salesid === '2' || salesid === '3' ? (
                    <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                      <div className="UI-action-buttons">
                        <Link
                          to={{ pathname: "/customercreditnotedetails" }}
                          state={{ id: item.id }}
                          className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-edit-button`}
                          style={{ textDecoration: "none" }}
                          onClick={(e) => e.stopPropagation()}
                          onMouseEnter={() =>
                            this.setState({ isActionHovered: `view-${item.id}` })
                          }
                          onMouseLeave={() => this.setState({ isActionHovered: null })}
                        >
                          <Tooltip title="View Details" arrow slotProps={{
                            popper: {
                              sx: { pointerEvents: 'none' },
                            },
                          }}>
                            <img
                              src={ViewIcon}
                              alt="View"
                              className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `view-${item.id}` ? 'UI-edit-icon-hover' : ''}`}
                            />
                          </Tooltip>
                        </Link>
                      </div>
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {this.renderPagination()}
      </>
    );
  }

  render() {
    const isMobile = this.state.isMobile;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
            <div className="UI-card">
              {/* Header */}
              <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
              <Breadcrumb breadcrumbs={[{name:"Home",path:"/sales"},{name:"Credit Notes",path:null}]}/>
                <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
                  <div>
                    <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>
                      Credit Notes
                    </h1>
                    <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                      Manage customer credit notes and refunds
                    </p>
                  </div>

                  <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
                    {/* Mobile Search */}
                    {isMobile && (
                      <input
                        type="text"
                        placeholder="Search credit notes..."
                        value={this.state.searchTerm}
                        onChange={(e) => this.handleSearch(e.target.value)}
                        className="UI-mobile-search-input"
                      />
                    )}

                    <div className={`UI-buttons-row ${isMobile ? 'UI-buttons-row-mobile' : ''}`}>
                      {/* Desktop Search Toggle */}
                      {!isMobile && (
                        <div
                          className={`UI-search-container ${this.state.showSearch ? 'UI-search-container-expanded' : ''} ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`}
                          onClick={() => {
                            if (!this.state.showSearch) this.setState({ showSearch: true });
                          }}
                          onMouseEnter={() => this.setState({ hovered: "search" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i
                            className="fa fa-search UI-search-icon"
                          />
                          {!this.state.showSearch && "Search"}
                          {this.state.showSearch && (
                            <input
                              type="text"
                              placeholder="Search credit notes..."
                              value={this.state.searchTerm}
                              onChange={(e) => this.handleSearch(e.target.value)}
                              className="UI-search-input"
                              autoFocus
                              onClick={(e) => e.stopPropagation()}
                              onBlur={() => {
                                if (this.state.searchTerm.trim() === "") {
                                  this.setState({ showSearch: false });
                                }
                              }}
                            />
                          )}
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>

              {this.state.loading ? (
                <div className="UI-loading-container">
                  {spin}
                </div>
              ) : (
                <>
                  {this.renderTabs()}
                  <div style={{ marginTop: '16px' }}>
                    {this.renderTable()}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(Creditnotes);